<template>
    <v-container fluid>
        <h1>방문신청하기</h1>

        <apply-edit ref="form"/>

        <v-footer app
                  fixed
                  outlined
                  height="50"
                  color="#fff"
                  class="px-2 justify-center"
        >
            <v-row justify="end" align="center" no-gutters>
                <v-col cols="auto">
                    <v-btn
                        depressed
                        class="secondary-btn"
                        @click="cancel"
                    >
                        취소
                    </v-btn>
                    <v-btn
                        depressed
                        width="100"
                        class="ml-2 primary-btn"
                        @click="submit"
                    >확인</v-btn>
                </v-col>
            </v-row>
        </v-footer>

    </v-container>
</template>

<script>
import TermsMixin from "@/pages/home/views/apply/TermsMixin";

export default {
    name: 'ApplyReservation',
    mixins: [TermsMixin],
    components: {
        ApplyEdit: () => import("@/components/apply/ApplyEdit")
    },

    async created() {
        await this.checkAgreeTerms();
    },

    methods: {
        async checkAgreeTerms() {
            const result = await this.isAgreeTerms();
            if (!result) {
                this.$window.alert('약관에 먼저 동의 후 신청해주세요.', 'error');
                await this.$router.push('/home/agreeTerms');
            }
        },

        cancel() {
            this.$router.push('/home');
        },

        submit() {
            this.$refs.form.submit();
        }
    }
}
</script>
